import Browser from '@mindful-web/marko-web/browser';
import Shared from '@randall-reilly/package-global/browser';

Shared(Browser);

export default Browser;
